import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'app-reprocess-confirm-dialog',
  templateUrl: './reprocess-confirm-dialog.component.html',
  styleUrls: ['./reprocess-confirm-dialog.component.css']
})
export class ReprocessConfirmDialogComponent implements OnInit {
  headerText: string;
  bodyText: string;

  constructor(public dialogRef: MatDialogRef<ReprocessConfirmDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any) {
    this.headerText = data && data.headerText ? data.headerText : 'Confirmation';
    this.bodyText = data && data.bodyText ? data.bodyText : 'Do you want to reprocess the automation again?';
  }

  ngOnInit() {
  }

  yes() {
    this.dialogRef.close('yes');
  }

  no() {
    this.dialogRef.close('no');
  }

  close() {
    this.dialogRef.close('close');
  }
}
